import script from "./UILoading.vue?vue&type=script&setup=true&lang=js"
export * from "./UILoading.vue?vue&type=script&setup=true&lang=js"

import "./UILoading.vue?vue&type=style&index=0&id=35dfddce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35dfddce"]])

export default __exports__